var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReferancePhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3.5V0.5H5V3.5H8V5.5H5V8.5H3V5.5H0V3.5H3ZM6 9.5V6.5H9V3.5H16L17.83 5.5H21C22.1 5.5 23 6.4 23 7.5V19.5C23 20.6 22.1 21.5 21 21.5H5C3.9 21.5 3 20.6 3 19.5V9.5H6ZM13 18.5C15.76 18.5 18 16.26 18 13.5C18 10.74 15.76 8.5 13 8.5C10.24 8.5 8 10.74 8 13.5C8 16.26 10.24 18.5 13 18.5ZM9.8 13.5C9.8 15.27 11.23 16.7 13 16.7C14.77 16.7 16.2 15.27 16.2 13.5C16.2 11.73 14.77 10.3 13 10.3C11.23 10.3 9.8 11.73 9.8 13.5Z",
    fill: "#A4B0BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferancePhoto);
export default __webpack_public_path__ + "static/media/referancePhoto.d66a7b72609a9d4e7b3bdcd834fd2190.svg";
export { ForwardRef as ReactComponent };